import _toLower from 'lodash/toLower';

const INTERNAL_DOMAINS = ['returnrabbit.com', 'shipstation.com', 'auctane.com'];

export default function isInternalUser(email = '') {
  const lowerCaseEmail = _toLower(email);
  return INTERNAL_DOMAINS.some((domain) => {
    return lowerCaseEmail.endsWith(`@${domain}`);
  });
}
